module.exports = "/_next/static/resources/pack-8f11d91696cc1c5b9a892dc7d5b5915c.jpg";